import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TabGroupComponent } from './tab-group/tab-group.component';
import {NzTabsModule} from 'ng-zorro-antd/tabs';
import {NzIconModule} from 'ng-zorro-antd/icon';
import {vssProviders} from '../../vss.providers';
import {NzModalService} from 'ng-zorro-antd/modal';
import {RouterModule} from '@angular/router';



@NgModule({
  declarations: [
    TabGroupComponent
  ],
  exports: [
    TabGroupComponent
  ],
    imports: [
        CommonModule,
        NzTabsModule,
        NzIconModule,
        RouterModule
    ],
  providers: [...vssProviders, NzModalService ]
})
export class TabGroupModule { }
